import { render, staticRenderFns } from "./PerformerTwitterItem.vue?vue&type=template&id=3dff883b&scoped=true&"
import script from "./PerformerTwitterItem.vue?vue&type=script&lang=js&"
export * from "./PerformerTwitterItem.vue?vue&type=script&lang=js&"
import style0 from "./PerformerTwitterItem.vue?vue&type=style&index=0&id=3dff883b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dff883b",
  null
  
)

export default component.exports